import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PRONTLIFE_WHATSAPP_NUMBER } from "constants/contacts";
import React from "react";
import { sendAnalyticEventWhatsapp } from "utils/store-link";

export const WhatsAppIcon = () => {
  return (
    <div className="absolute-whatsapp-button">
      <a
        href={`https://api.whatsapp.com/send?phone=+${PRONTLIFE_WHATSAPP_NUMBER}&text=Olá, quero conhecer melhor o ProntLife.`}
        rel="noopener noreferrer"
        target="_blank"
        onClick={() => sendAnalyticEventWhatsapp()}
      >
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon
            fixedWidth
            icon={faCircle}
            color={"#39b54a"}
            size="3x"
          />
          <FontAwesomeIcon
            fixedWidth
            size="2x"
            color="#FFF"
            icon={["fab", "whatsapp"]}
            style={{ margin: "-9px 0px -9px 10px" }}
          />
        </span>
      </a>
    </div>
  );
};
